 // Scripting to handle tabs interaction
(function($){

	$('#tab-nav-wrapper .tab-nav:not(:first)').addClass('inactive');
	$('.tab').hide();
	$('.tab:first').show();
	    
	$('#tab-nav-wrapper .tab-nav').click(function(){
		var t = $(this).attr('id');
			if($(this).hasClass('inactive')){ //this is the start of our condition 
			$('#tab-nav-wrapper .tab-nav').addClass('inactive');           
			$(this).removeClass('inactive');

			$('.tab').hide();
			$('#'+ t + 'C').fadeIn('slow');
		}
	});

})(jQuery);
